import { FC } from 'react';
import { BsArrowLeftShort } from "react-icons/bs";
import { BsCalendar2Date } from "react-icons/bs";
import { Link } from 'react-router-dom';

interface PillProps {
  text: string;
  colorClass: string;
  size?: keyof PillSize;
  icon?: IconType;
  textColor?: string;
  clickable?: boolean;
  path?: string;
  extraClass?: string;
}

interface PillSize {
  small: string;
  medium: string;
  large: string;
}

const pillSizes: PillSize = {
  small: 'px-2 py-0.5 text-xs',
  medium: 'px-3 py-1 text-sm', 
  large: 'px-4 py-2 text-base'
};

// Add this type for supported icons
type IconType = 'arrow' | 'calendar' | undefined;

// Add this function to select icons
const getIcon = (iconType?: IconType) => {
  switch (iconType) {
    case 'arrow':
      return <BsArrowLeftShort className="inline mr-1" />;
    case 'calendar':
      return <BsCalendar2Date className="inline mr-1" />;
    default:
      return null;
  }
};

const Pill: FC<PillProps> = ({ text, colorClass, size = 'medium', icon, textColor, clickable, path, extraClass }) => {
  const textColorClass = textColor ? `text-${textColor}` : 'text-white';
  const hoverClass = (clickable || path) ? 'hover:brightness-90 underline cursor-pointer transition-all' : '';

  const pillContent = (
    <>
      {getIcon(icon)}{text}
    </>
  );

  return path ? (
    <Link to={path} className={`whitespace-nowrap rounded-full ${textColorClass} ${pillSizes[size]} ${colorClass} ${hoverClass}`}>
      {pillContent}
    </Link>
  ) : (
    <span className={`whitespace-nowrap rounded-full ${textColorClass} ${pillSizes[size]} ${colorClass} ${hoverClass} ${extraClass}`}>
      {pillContent}
    </span>
  );
};

export default Pill;